module.exports = __webpack_public_path__ + "img/iconfish.eb013eb9.svg";